import { useState } from "react";
import dataService from "../../../../helpers/dataService";

const useContractsStat = ({ url, year }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setDatas] = useState(null);

  const getContractsStat = () => {
    setIsLoading(true);
    dataService.post(
      url,
      {},
      setDatas,
      (err) => {},
      () => setIsLoading(false)
    );
  };

  return {
    isLoading,
    datas,
    getContractsStat,
  };
};

export default useContractsStat;
